/**
 * Only one thing plays at a time.
 *
 * A thread can hold a dozen clips and voice notes, and without this, scrolling
 * through and tapping two of them gives you two soundtracks at once.
 *
 * One registry per media kind rather than one shared between them: the video
 * player and the voice player each police their own, which is the behaviour
 * these screens have always had. Pass the same registry to every instance of
 * one player.
 */
export type SoloPlayback = {
  /** Pause whoever is playing, then take the spot. */
  claim: (element: HTMLMediaElement) => void;
  /** Give it up, if this element still holds it. */
  release: (element: HTMLMediaElement) => void;
};

export const createSoloPlayback = (): SoloPlayback => {
  let current: HTMLMediaElement | null = null;

  return {
    claim: (element) => {
      if (current && current !== element) current.pause();
      current = element;
    },
    release: (element) => {
      if (current === element) current = null;
    },
  };
};
